export const removeItem = (array, itemIndex) => {
  array.splice(itemIndex, 1);
  return array;
};
